import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, patchData, postData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import {
	KSK2040_R01Dto,
	KSK2040_R01HeaderDto,
} from "./Dto_KSK2040_R01";
import { KSK2040_R01Filter } from "./Store_KSK2040_R01";

const baseUrl = `${config.apiUrl}/KSK2040_R01`;

export interface KSK2040_R01ListParams {
	compCd?: string;
	startDate?: string;
	endDate?: string;
	workplaceCd?: string;
	itemCd?: string;
	productEmp?: string;
}

export const getKSK2040_R01Params = (
	filter: Partial<KSK2040_R01Filter>,
): KSK2040_R01ListParams => ({
	compCd: filter.compCd || undefined,
	startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
	endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
	workplaceCd: filter.workplaceCd || undefined,
	itemCd: filter.itemCd || undefined,
	productEmp: filter.productEmp || undefined,
});

export const getKSK2040_R01List = async (
	option: "search" | "refetch",
	filter: Partial<KSK2040_R01Filter>,
) => getData<ResponseDto<KSK2040_R01HeaderDto[]>>(
	`${baseUrl}/${option}`,
	{ params: getKSK2040_R01Params(filter) },
);

export const getKSK2040_R01AllCount = async (filter: Partial<KSK2040_R01Filter>) =>
	getData<ResponseDto<number>>(
		`${baseUrl}/allCount`,
		{ params: getKSK2040_R01Params(filter) },
	);

export const getKSK2040_R01DetailList = async (
	productResultNo: string,
	inspectType: string,
) => getData<ResponseDto<KSK2040_R01Dto>>(
	`${baseUrl}/detail`,
	{ params: { productResultNo, inspectType } },
);

export const postKSK2040_R01 = async (data: KSK2040_R01Dto) =>
	postData<KSK2040_R01Dto, ResponseDto<KSK2040_R01Dto>>(baseUrl, data);

export const patchKSK2040_R01 = async (data: KSK2040_R01Dto) =>
	patchData<KSK2040_R01Dto, ResponseDto<KSK2040_R01Dto>>(baseUrl, data);

export const deleteKSK2040_R01 = async (data: KSK2040_R01HeaderDto[]) =>
	postData<KSK2040_R01HeaderDto[], ResponseDto<number>>(`${baseUrl}/delete`, data);
